import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  payment: null,
  payments: [],
  customerPayments: [],
  success: false,
  error: null,
  message: null,
};

export const paymentReducer = createReducer(initialState, (builder) => {
  builder
    // Payment Creation
    .addCase('createPaymentRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('createPaymentSuccess', (state, action) => {
      state.isLoading = false;
      state.payment = action.payload;
      state.success = true;
      state.message = "Payment created successfully";
    })
    .addCase('createPaymentFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Fetch All Payments
    .addCase('getAllPaymentsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllPaymentsSuccess', (state, action) => {
      state.isLoading = false;
      state.payments = action.payload;
    })
    .addCase('getAllPaymentsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Single Payment
    .addCase('getPaymentRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getPaymentSuccess', (state, action) => {
      state.isLoading = false;
      state.payment = action.payload;
    })
    .addCase('getPaymentFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Update Payment
    .addCase('updatePaymentRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updatePaymentSuccess', (state, action) => {
      state.isLoading = false;
      state.payment = action.payload;
      state.success = true;
      state.message = "Payment updated successfully";
    })
    .addCase('updatePaymentFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Delete Payment
    .addCase('deletePaymentRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deletePaymentSuccess', (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.message = action.payload;
    })
    .addCase('deletePaymentFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Customer Payments
    .addCase('getCustomerPaymentsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getCustomerPaymentsSuccess', (state, action) => {
      state.isLoading = false;
      state.customerPayments = action.payload;
    })
    .addCase('getCustomerPaymentsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Print Customer Invoice
    .addCase('printCustomerInvoiceRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('printCustomerInvoiceSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase('printCustomerInvoiceFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Clear Errors
    .addCase('clearPaymentErrors', (state) => {
      state.error = null;
    })

    // Clear Messages
    .addCase('clearPaymentMessages', (state) => {
      state.message = null;
      state.success = false;
    })

    // Reset Payment State
    .addCase('resetPaymentState', (state) => {
      state.payment = null;
      state.error = null;
      state.message = null;
      state.success = false;
      state.isLoading = false;
    });
});